import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {SuppliersUnit, SuppliersUnitsFilters, SuppliersUnitUI} from '@store/suppliers/units/suppliers-units.model';
import {GlobalStatus} from '@store/common/globalStatus.enum';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface SuppliersUnitsState {
  status?: GlobalStatus;
  filters: SuppliersUnitsFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const suppliersUnitsStore = createStore(
  {name: 'suppliers-units'},
  withProps<SuppliersUnitsState>({
    status: undefined,
    filters: {search: '', tableFilters: SuppliersUnitsFilters.initTableFilters()},
    sort: {
      field: 'organisationUnit.name',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<SuppliersUnit>(),
  withUIEntities<SuppliersUnitUI>(),
  withPagination(),
  withRequestsStatus(),
);
